import { render, staticRenderFns } from "./NSchedule.vue?vue&type=template&id=32851d85&scoped=true"
import script from "./NSchedule.vue?vue&type=script&lang=ts&setup=true"
export * from "./NSchedule.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NSchedule.vue?vue&type=style&index=0&id=32851d85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32851d85",
  null
  
)

export default component.exports